export default __webpack_public_path__ + "static/Quantico-Regular-9d0882b9932a6155db07b77627828a72.ttf";